module.exports = __webpack_public_path__ + "img/Shaman-draenei-m-60.19f3cf84.gif";